export type { BannerProps } from './banner';
export { default } from './banner';
